<template>
  <div>
    <template v-if="loading">
      <div
        class="d-flex vertical-center justify-content-center align-items-center"
        style="height: 50vh; display: flex"
      >
        <LoadingMDL />
      </div>
    </template>
    <template v-else>
      <div style="background-color: #e6efff">
        <div class="position">
          <step-progress
            :steps="mySteps"
            :current-step="currentStep"
            icon-class="fa fa-check fa-lg"
          ></step-progress>
          <div v-show="showQuiz === true">
            <Quiz
              :content="content_question"
              :lang="language"
              @nextRoute="nextRoute"
              @prevRoute="prevRoute"
            />
          </div>
          <div v-show="showQuiz === false">
            <ChatMessage
              :content="content_message"
              @nextPage="nextPage"
              :lang="language"
            />
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import LoadingMDL from '@/components/loading/LoadingMDL';
import ChatMessage from './components/ChatMessage.vue';
import Quiz from '@/components/template/Chinese2/Quiz';
import StepProgress from 'vue-step-progress';
import 'vue-step-progress/dist/main.css';

export default {
  components: {
    ChatMessage,
    Quiz,
    LoadingMDL,
    StepProgress,
  },
  name: 'QZ03',
  props: {},
  data() {
    return {
      showQuiz: false,
      content_message: [],
      content_question: [],
      loading: true,
      language: 'en',
      navigate: '',
      startTime: '',
      condition: [],
      criteria_id: '',
      topic: {},
      // code: "605418cb883ae722ba1b0c5f",
      code: '',
      section: '',
      chapter: null,
      mySteps: [],
      currentStep: null,
      v3Data: null,
      v3Score: 0,
      nextPath: null,
    };
  },
  methods: {
    onLoadData() {
      this.currentRoute = this.$route.name + '-' + this.$route.params.id;
      this.courseData = this.$store.getters['necessary/getLerningCourse'];
      this.code = this.courseData._id;
      this.section = this.$store.getters['necessary/getUserCourseSection'];
      this.language = this.$store.getters['language/getLanguage'];
      //dispatch
      this.$store.dispatch('v3/fetchTemplateByCode', this.currentRoute);
    },

    nextPage: function (val) {
      this.showQuiz = val;
    },
    nextRoute: function (val) {
      if (val == null) {
        alert('Please select answer');
        return;
      }
      this.commitUserProgress(val);
    },
    commitUserProgress: function (answer) {
      this.loading = true;

      // สำหรับเช็คคำตอบว่าถูกต้องไหม พร้อมให้คะแนน
      let trueAnswer = null;
      for (let i = 0; i < this.content_question.choices.length; i++) {
        const element = this.content_question.choices[i];
        if (element.answer == 'TRUE') {
          trueAnswer = element.question;
        }
      }
      if (trueAnswer == answer) {
        this.v3Score = 1;
      }

      //redirect
      this.commitPayloadData();
    },
    prevRoute: function (val) {
      this.showQuiz = val;
    },
    setProgress: function (value) {
      return new Promise((resolve, reject) => {
        value.chapter.item.map((i) => {
          switch (i.content.type) {
            case 'topic':
              this.mySteps.push('Topic');
              break;
            case 'flipcard':
              this.mySteps.push('Vocabulary');
              break;
            case 'assignment':
              this.mySteps.push('Assignment');
              break;
            case 'test':
              this.mySteps.push('Test');
              break;
            default:
              this.mySteps.push(i.content.type);
              break;
          }
        });
        // value.checkPoints.map((i) => {
        //   if (i._id.topic == value.topicPosition.codeItem) {

        //   }
        // });
        this.currentStep = value.topicPosition.index - 1;
        resolve();
      });
    },
    resetLocalState() {
      this.showQuiz = false;
      this.content_message = [];
      this.content_question = [];
      this.startTime = '';
      this.condition = [];
      this.criteria_id = '';
      this.topic = {};
      this.chapter = null;
      this.mySteps = [];
      this.currentStep = null;
      this.v3Score = 0;
    },
    commitPayloadData() {
      const path = this.navigate;
      //payload here
      const payload = {
        codeItem: this.v3Data.codeItem,
        score: this.v3Score,
        maxScore: 1,
      };

      //commit add payload stack
      this.$store.commit('v4/addPayloadStack', payload);
      //var
      const currentDataStack = [...this.$store.state.v4.v4DataStack];
      const currentCodeItem = this.v3Data.codeItem;
      //get last code item form backend
      const lastCodeItem = this.v3Data.lastContent;
      //check store
      if (currentDataStack.length === 0) {
        //no dispatch if array empty
      } else {
        if (currentCodeItem === lastCodeItem) {
          this.$store.dispatch('v4/v4ProgressAndScoreCalc', {
            mainCodeItem: this.v3Data.mainCodeItem,
            mainType: this.v3Data.mainType,
            mainContent: this.v3Data.mainContent,
            dataStack: currentDataStack,
            pages: this.v3Data.pages,
            courseId: this.$store.state.v3.v3EnrollData.data.courseinfo,
            section: this.$store.state.v3.v3EnrollData.data.section,
          });

          this.nextPath = path;
        } else {
          //onNext
          const splitPath = path.split('-');
          const nextPath = `/v4/${splitPath[0]}/${splitPath[1]}`;
          this.$router.push(nextPath);
        }
      }
    },
  },
  computed: {
    ...mapGetters({
      getTemplateAndProgress: 'template/getTemplateAndProgress',
      getResponseStatus: 'template/getResponseStatus',
      storeLanguage: 'language/getLanguage',
      getTemplatev3: 'v3/getTemplates',
      saveContentStatusv4: 'v4-data/saveContentStatusv4',
    }),
  },
  watch: {
    getTemplatev3: function (val) {
      if (!val) return;
      this.mySteps = [];
      this.startTime = this.$helpers.getDateFormat();

      this.v3Data = val;
      const template = val.templates[0];
      //content
      const length_content = template.content.item.length;
      this.content_message = template.content.item.slice(0, length_content - 1);
      this.content_question = template.content.item[length_content - 1];

      this.navigate = template.navigate.next.action;

      this.$store.dispatch('v4/checkCurrentMainCode', this.v3Data);

      this.loading = false;
    },
    saveContentStatusv4: function (val) {
      // console.log(val, 'QZ03 saveContent Call');
      //if this next path exist
      if (this.nextPath) {
        this.loading = true;

        const splitPath = this.nextPath.split('-');
        const onNext = `/v4/${splitPath[0]}/${splitPath[1]}`;
        //to LTK 01
        this.$router.push(onNext);
      }
    },
    '$route.params.id'() {
      //use to watch param id if changes
      //clear old state and Load new data
      this.loading = true;

      this.resetLocalState();
      this.onLoadData();
    },

    storeLanguage: function (value) {
      this.language = value;
    },
  },
  created() {},
  mounted() {
    this.onLoadData();
  },
  beforeDestroy() {},
};
</script>

<style scoped lang="scss">
.position {
  padding-top: 10%;
}

::v-deep .step-progress__wrapper {
  width: 40%;
}

::v-deep .step-progress__wrapper-before {
  top: 50%;
  height: 10px;
  opacity: 0.5;
  background-color: #3b3b38 !important;
}

::v-deep .step-progress__step--valid:after {
  background-color: #1d5bd7;
}

::v-deep .step-progress__step--valid:after {
  border: #1d5bd7 solid !important;
}

::v-deep .step-progress__step--active:after {
  border: #1d5bd7 solid !important;
}

::v-deep .step-progress__step--active .step-progress__step-label,
.step-progress__step--active span {
  color: #1d5bd7;
}

::v-deep .step-progress__wrapper-after {
  top: 50%;
  height: 10px;
  background-color: #1d5bd7 !important;
  opacity: 0.5;
}

::v-deep .step-progress__step span {
  font-size: 0px;
}

::v-deep svg:not(:root).svg-inline--fa {
  width: 20px;
  height: 20px;
}

::v-deep .step-progress__step-label {
  top: -50px;
}

::v-deep .step-progress__step--valid .step-progress__step-label {
  color: #1d5bd7;
}

::v-deep .step-progress__step:after {
  width: 40px;
  height: 40px;
  border: #808080 solid;
}

::v-deep .step-progress__bar {
  margin-bottom: 10px;
  height: 6s0px;
}

@media only screen and (min-width: 600px) and (max-width: 768px) {
  .position {
    padding-top: 20%;
  }

  ::v-deep .step-progress__wrapper {
    width: 70%;
  }
}

@media only screen and (min-width: 1000px) and (max-width: 1366px) {
  .position {
    padding-top: 15%;
  }

  ::v-deep .step-progress__wrapper {
    width: 80%;
  }
}

@media only screen and (min-width: 300px) and (max-width: 599px) {
  .position {
    padding-top: 20%;
  }

  ::v-deep .step-progress__wrapper {
    width: 75%;
  }
}
</style>
